import { DATE_PRESETS } from './filters.js';
import { ogVarNames } from './css.js';
/** disp 의 추가 슬롯(디테일·그룹 푸터) 표시: 이 값 이하는 extras[EXTRA - v] */
export const EXTRA = -(1 << 30);
/** 줄바꿈 셀의 줄 높이 (css .og-wrap line-height 와 같아야 함) */
export const WRAP_LINE_PX = 16;
/** 새 항목 행(NewItemRow)에 포커스가 있을 때의 focus.vi (disp 밖 값) */
export const NIR = -2;
/** 콤보 다중 컬럼 목록 줄 높이 (css .og-dlr 와 같아야 함) */
export const DROP_RH = 24;
/** 대화상자 안 Tab 갇힘 (마지막 → 처음, Shift+Tab 처음 → 마지막) */
export function trapTab(box, e) {
    const f = [...box.querySelectorAll('button:not([disabled]),input:not([disabled]):not([type=hidden]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])')].filter(x => x.offsetParent !== null || x === document.activeElement);
    if (!f.length)
        return;
    const a = f[0], z = f[f.length - 1], cur = document.activeElement;
    if (e.shiftKey && (cur === a || !box.contains(cur))) {
        e.preventDefault();
        z.focus();
    }
    else if (!e.shiftKey && (cur === z || !box.contains(cur))) {
        e.preventDefault();
        a.focus();
    }
}
/** 그룹 머리행 제목을 왼쪽 고정 구역에 둘 최소 너비(px) */
export const GROUP_LABEL_MIN_PANE = 160;
const blankV = (v) => v == null || v === '';
/** 추가 후 손대지 않은 행인가 (순수): 모든 값이 추가할 때 값과 같음 (null 과 '' 는 같게 봄) */
export function isUntouchedRow(cur, init) {
    for (const k of new Set([...Object.keys(cur), ...Object.keys(init)])) {
        const a = cur[k], b = init[k];
        if (blankV(a) && blankV(b))
            continue;
        if (a !== b && String(a) !== String(b))
            return false;
    }
    return true;
}
export const CHECKISH = new Set(['check', 'check3', 'radio']);
/**
 * 비율 너비 (순수). cols 마다 { width(기본 너비), flex?(비율, 0/없음 = 고정), min?, max? }.
 * 고정 컬럼을 뺀 남는 너비를 flex 비율로 나누고, min/max 에 걸린 컬럼은 묶어 두고 나머지로 다시 나눈다. 정수 px, 합 = avail (남으면 마지막 flex 컬럼에)
 */
export function fitWidths(cols, avail) {
    const out = cols.map(c => c.width);
    let free = cols.map((c, i) => (c.flex && c.flex > 0 ? i : -1)).filter(i => i >= 0);
    if (!free.length)
        return out;
    let rest = avail - cols.reduce((a, c) => a + (c.flex && c.flex > 0 ? 0 : c.width), 0);
    for (let guard = 0; guard < cols.length + 1 && free.length; guard++) {
        const tf = free.reduce((a, i) => a + cols[i].flex, 0);
        const clamped = [];
        for (const i of free) {
            const c = cols[i], w = rest * c.flex / tf, lo = c.min ?? 30, hi = c.max ?? Infinity;
            if (w < lo) {
                out[i] = lo;
                clamped.push(i);
            }
            else if (w > hi) {
                out[i] = hi;
                clamped.push(i);
            }
        }
        if (!clamped.length) {
            let used = 0;
            free.forEach(i => { out[i] = Math.floor(rest * cols[i].flex / tf); used += out[i]; });
            const last = free[free.length - 1], extra = rest - used;
            if (extra > 0 && out[last] + extra <= (cols[last].max ?? Infinity))
                out[last] += extra;
            return out;
        }
        for (const i of clamped)
            rest -= out[i];
        free = free.filter(i => !clamped.includes(i));
    }
    return out;
}
/** 스핀 편집기 증감 (순수): 숫자 문자열 + step, min·max 로 자름. 소수 자릿수는 step·현재 값 중 긴 쪽 */
export function stepNumber(text, step, min, max) {
    const cur = Number(String(text ?? '').replace(/,/g, '').trim() || 0);
    const base = isNaN(cur) ? 0 : cur;
    const dec = Math.max((String(step).split('.')[1] ?? '').length, (String(text ?? '').replace(/,/g, '').trim().split('.')[1] ?? '').length);
    let v = Math.round((base + step) * 10 ** dec) / 10 ** dec;
    if (min != null && v < min)
        v = min;
    if (max != null && v > max)
        v = max;
    return v.toFixed(dec);
}
/** 바꾸기 (순수): 일치하면 바꾼 문자열, 아니면 null. whole = 셀 전체 일치만 */
export function replaceText(value, find, repl, opts = {}) {
    if (value == null || !find)
        return null;
    const s = String(value), f = opts.matchCase ? find : find.toLowerCase(), t = opts.matchCase ? s : s.toLowerCase();
    if (opts.whole)
        return t === f ? repl : null;
    if (!t.includes(f))
        return null;
    let out = '', i = 0;
    for (let j = t.indexOf(f); j >= 0; j = t.indexOf(f, i)) {
        out += s.slice(i, j) + repl;
        i = j + f.length;
    }
    return out + s.slice(i);
}
/** 3상태 체크 순환 (순수): 꺼짐 → 켜짐 → 미정 → 꺼짐. values = [켜짐, 꺼짐, 미정] */
export function cycleCheck3(v, values) {
    const [on, off, mixed] = values;
    return v === on || v === true ? mixed : v === mixed ? off : on;
}
/** 접힌 그룹 때문에 숨는 컬럼 id (순수). collapsed = 접힌 그룹 머리글 이름 */
export function collapsedHidden(groups, collapsed) {
    const out = new Set();
    const leaves = (g, acc, d = 0) => { if (d > 16)
        return acc; for (const ch of g.children ?? [])
        typeof ch === 'string' ? acc.push(ch) : leaves(ch, acc, d + 1); return acc; };
    const walk = (g, d = 0) => {
        if (!g || d > 16)
            return;
        if (g.collapsible && collapsed.has(g.header)) {
            const ids = leaves(g, []), keep = new Set(g.showWhenCollapsed?.length ? g.showWhenCollapsed : ids.slice(0, 1));
            for (const id of ids)
                if (!keep.has(id))
                    out.add(id);
        }
        for (const ch of g.children ?? [])
            if (typeof ch !== 'string')
                walk(ch, d + 1);
    };
    for (const g of groups ?? [])
        walk(g);
    return out;
}
/** 컬럼 id → 바깥부터 그룹 사슬 (순수) */
export function headerChains(groups) {
    const chains = new Map();
    let depth = 0;
    const walk = (g, path, guard) => {
        if (guard > 16 || !g || !Array.isArray(g.children) || path.includes(g))
            return; // 순환 참조 방지
        const p = [...path, g];
        for (const ch of g.children) {
            if (typeof ch === 'string') {
                if (!chains.has(ch)) {
                    chains.set(ch, p);
                    depth = Math.max(depth, p.length);
                }
            }
            else
                walk(ch, p, guard + 1);
        }
    };
    for (const g of groups ?? [])
        walk(g, [], 0);
    return { chains, depth };
}
/**
 * 저장소(서버·localStorage)에서 온 레이아웃 정리 (순수). 화면에 HTML·스타일로 들어가는 값이 많으므로
 * 숫자는 숫자로, 정해진 값은 목록 안에서만, 문자열은 문자열로 — 그 밖은 버린다.
 */
export function sanitizeLayout(l) {
    if (!l || typeof l !== 'object' || !Array.isArray(l.columns))
        return null;
    const AGG = ['sum', 'avg', 'count', 'min', 'max'];
    const numIn = (v, lo, hi) => { const n = Number(v); return Number.isFinite(n) ? Math.max(lo, Math.min(hi, n)) : undefined; };
    const BOOL = ['hidden', 'required', 'wrap', 'sortable', 'filterable', 'upper', 'suppress', 'privacy'];
    const STR = ['id', 'header', 'format', 'dateFormat', 'editor', 'comboShow', 'groupInterval', 'expr', 'merge'];
    const columns = l.columns.filter((c) => c && typeof c === 'object' && typeof c.id === 'string').map((c) => {
        const o = { id: c.id };
        for (const k of LAYOUT_COLUMN_KEYS) {
            if (!(k in c) || k === 'id')
                continue;
            const v = c[k];
            if (k === 'width') {
                const n = numIn(v, 10, 4000);
                if (n != null)
                    o.width = n;
            }
            else if (k === 'decimals' || k === 'maxLength') {
                const n = numIn(v, 0, 100000);
                if (n != null)
                    o[k] = n;
            }
            else if (k === 'pinned') {
                if (v === true || v === false || v === 'left' || v === 'right')
                    o.pinned = v;
            }
            else if (k === 'align') {
                if (v === 'left' || v === 'center' || v === 'right')
                    o.align = v;
            }
            else if (k === 'summary') {
                if (AGG.includes(v))
                    o.summary = v;
            }
            else if (k === 'summaries') {
                if (Array.isArray(v))
                    o.summaries = v.filter((x) => AGG.includes(x));
            }
            else if (k === 'summaryExpr') {
                if (typeof v === 'string')
                    o.summaryExpr = v;
            }
            else if (BOOL.includes(k)) {
                if (typeof v === 'boolean' || (k === 'privacy' && typeof v === 'string') || (k === 'merge' && typeof v === 'string'))
                    o[k] = v;
            }
            else if (STR.includes(k)) {
                if (typeof v === 'string' || (k === 'merge' && typeof v === 'boolean') || (k === 'editor' && v === false))
                    o[k] = v;
            }
        }
        return o;
    });
    const options = {};
    if (l.options && typeof l.options === 'object')
        for (const k of LAYOUT_OPTION_KEYS) {
            if (!(k in l.options))
                continue;
            const v = l.options[k];
            if (k === 'rowHeight' || k === 'headerHeight') {
                const n = numIn(v, 16, 200);
                if (n != null)
                    options[k] = n;
            }
            else if (k === 'pageSize') {
                const n = numIn(v, 0, 100000);
                if (n != null)
                    options[k] = n;
            }
            else if (k === 'footerLabel' || k === 'emptyText' || k === 'enterKey') {
                if (typeof v === 'string')
                    options[k] = v;
            }
            else if (typeof v === 'boolean')
                options[k] = v;
        }
    const sort = Array.isArray(l.sort) ? l.sort.filter((k) => k && typeof k.col === 'string').map((k) => ({ col: k.col, dir: k.dir === 'desc' ? 'desc' : 'asc' })) : [];
    const groupBy = Array.isArray(l.groupBy) ? l.groupBy.filter((g) => typeof g === 'string') : [];
    const hgClean = (gs, d) => d > 8 ? [] : gs.filter((g) => g && typeof g.header === 'string' && Array.isArray(g.children)).map((g) => ({ header: g.header, children: g.children.flatMap((c) => typeof c === 'string' ? [c] : c && typeof c === 'object' ? hgClean([c], d + 1) : []) }));
    const headerGroups = Array.isArray(l.headerGroups) ? hgClean(l.headerGroups, 0) : undefined;
    const rl = l.rowLayout, int = (v, lo, hi) => { const n = numIn(v, lo, hi); return n == null ? undefined : Math.round(n); };
    const rowLayout = rl && typeof rl === 'object' && Array.isArray(rl.cells) && int(rl.rows, 1, 20) ? {
        rows: int(rl.rows, 1, 20),
        cells: rl.cells.filter((x) => x && typeof x.col === 'string').slice(0, 200).map((x) => ({ col: x.col, row: int(x.row, 0, 19) ?? 0, ...(x.rowSpan != null ? { rowSpan: int(x.rowSpan, 1, 20) } : {}), ...(x.colSpan != null ? { colSpan: int(x.colSpan, 1, 50) } : {}), ...(x.colIndex != null ? { colIndex: int(x.colIndex, 0, 100) } : {}) })),
        ...(Array.isArray(rl.colWidths) ? { colWidths: rl.colWidths.slice(0, 100).map((w) => numIn(w, 10, 4000) ?? 100) } : {}),
        ...(rl.frozen != null ? { frozen: int(rl.frozen, 0, 100) } : {}), ...(rl.frozenRight != null ? { frozenRight: int(rl.frozenRight, 0, 100) } : {}),
    } : undefined;
    const pairs = (a) => a.filter((x) => Array.isArray(x) && typeof x[0] === 'string' && typeof x[1] === 'string').slice(0, 10000).map((x) => [x[0], x[1]]);
    const r = l.rows, strs = (a) => (Array.isArray(a) ? a.filter((k) => typeof k === 'string').slice(0, 10000) : undefined);
    const rows = r && typeof r === 'object' ? {
        ...(Array.isArray(r.heights) ? { heights: r.heights.filter((x) => Array.isArray(x) && typeof x[0] === 'string' && numIn(x[1], 4, 2000) != null).slice(0, 10000).map((x) => [x[0], numIn(x[1], 4, 2000)]) } : {}),
        ...(strs(r.hidden) ? { hidden: strs(r.hidden) } : {}), ...(strs(r.pinTop) ? { pinTop: strs(r.pinTop) } : {}), ...(strs(r.pinBottom) ? { pinBottom: strs(r.pinBottom) } : {}),
        ...(Array.isArray(r.locked) ? { locked: pairs(r.locked) } : {}), ...(Array.isArray(r.unlocked) ? { unlocked: pairs(r.unlocked) } : {}),
        ...(typeof r.protect === 'boolean' ? { protect: r.protect } : {}),
    } : undefined;
    const filters = l.filters ? sanitizeFilters(l.filters) : undefined;
    return { v: 1, columns, options, sort, groupBy, ...(headerGroups ? { headerGroups } : {}), ...(rowLayout ? { rowLayout } : {}), ...(rows ? { rows } : {}), ...(filters ? { filters } : {}) };
}
/** 값 목록 요약 (순수): count = 빈 값 아닌 개수, 숫자(문자 숫자 "1,234" 포함)만 합계·평균·최소·최대 */
export function summarizeValues(vals) {
    let count = 0, n = 0, sum = 0, min = Infinity, max = -Infinity;
    for (const v of vals) {
        if (v == null || v === '')
            continue;
        count++;
        const x = typeof v === 'number' ? v : typeof v === 'string' && /^\s*[-+]?[\d,]*\.?\d+\s*$/.test(v) ? Number(v.replace(/,/g, '')) : typeof v === 'boolean' ? NaN : NaN;
        if (!Number.isFinite(x))
            continue;
        n++;
        sum += x;
        if (x < min)
            min = x;
        if (x > max)
            max = x;
    }
    return { count, numCount: n, sum: n ? sum : null, avg: n ? sum / n : null, min: n ? min : null, max: n ? max : null };
}
/** 컬럼 권한 판단 (순수): access[role] → access['*'] → 'edit' */
export function columnAccessOf(def, role) {
    const a = def?.access;
    if (!a)
        return 'edit';
    return (role != null ? a[role] : undefined) ?? a['*'] ?? 'edit';
}
/** 멀티로우 배치 계산 (순수). colIndex 생략 시 그 줄의 비어 있는 다음 칸 (rowSpan 으로 내려온 칸은 건너뜀).
 *  격자 열 너비 = colWidths[i] 또는 그 열 한 칸짜리 셀 컬럼 width 의 최대값(없으면 100). 결과는 줄·열 순 */
export function placeRowLayout(rl, widthOf, pinOf) {
    const cells = rl.cells.map(x => ({ col: x.col, row: x.row | 0, rowSpan: Math.max(1, x.rowSpan ?? 1), colSpan: Math.max(1, x.colSpan ?? 1), colIndex: x.colIndex ?? -1, left: 0, width: 0 })), occ = new Set();
    const mark = (x) => { for (let r = x.row; r < x.row + x.rowSpan; r++)
        for (let k = x.colIndex; k < x.colIndex + x.colSpan; k++)
            occ.add(r + ',' + k); };
    cells.filter(x => x.colIndex >= 0).forEach(mark);
    for (const x of cells)
        if (x.colIndex < 0) {
            let k = 0;
            while (occ.has(x.row + ',' + k))
                k++;
            x.colIndex = k;
            mark(x);
        }
    const n = cells.reduce((m, x) => Math.max(m, x.colIndex + x.colSpan), 0);
    const gw = Array.from({ length: n }, (_, i) => rl.colWidths?.[i] ?? (Math.max(0, ...cells.filter(c => c.colIndex === i && c.colSpan === 1).map(c => widthOf(c.col) ?? 100)) || 100));
    const at = (i) => { let l = 0; for (let k = 0; k < i; k++)
        l += gw[k]; return l; };
    for (const x of cells) {
        x.left = at(x.colIndex);
        x.width = at(x.colIndex + x.colSpan) - x.left;
    }
    cells.sort((a, b) => a.row - b.row || a.colIndex - b.colIndex);
    // 고정 영역: 왼쪽 = 격자 열 [0, L), 오른쪽 = [R, n). 고정 컬럼(pinned) 셀이 있는 열까지, 경계에 걸친 셀은 고정 쪽으로 넓힘
    let L = Math.max(0, Math.min(n, rl.frozen ?? 0)), R = n - Math.max(0, Math.min(n, rl.frozenRight ?? 0));
    for (const x of cells) {
        const p = pinOf?.(x.col);
        if (p === 'left')
            L = Math.max(L, x.colIndex + x.colSpan);
        else if (p === 'right')
            R = Math.min(R, x.colIndex);
    }
    for (let ch = true; ch;) {
        ch = false;
        for (const x of cells)
            if (x.colIndex < L && x.colIndex + x.colSpan > L) {
                L = x.colIndex + x.colSpan;
                ch = true;
            }
    }
    for (let ch = true; ch;) {
        ch = false;
        for (const x of cells)
            if (x.colIndex < R && x.colIndex + x.colSpan > R) {
                R = x.colIndex;
                ch = true;
            }
    }
    if (R < L)
        R = n;
    const out = cells.map(x => { const pane = x.colIndex + x.colSpan <= L ? 0 : x.colIndex >= R ? 2 : 1; return { ...x, pane, pl: x.left - (pane === 1 ? at(L) : pane === 2 ? at(R) : 0) }; });
    return { cells: out, colWidths: gw, total: at(n), paneWidths: [at(L), at(R) - at(L), at(n) - at(R)], frozen: L, frozenRight: n - R };
}
const DATE_PRESET_KEYS = DATE_PRESETS.map(p => p[0]);
const FILTER_OPS = ['=', '!=', '>', '>=', '<', '<=', 'contains', 'notContains', 'startsWith', 'endsWith', 'like', 'notLike', 'in', 'notIn', 'between', 'notBetween', 'empty', 'notEmpty'];
const prim = (v) => v === null || typeof v === 'string' || (typeof v === 'number' && Number.isFinite(v)) || typeof v === 'boolean';
const primOrList = (v) => prim(v) || (Array.isArray(v) && v.length <= 10000 && v.every(prim));
/** 저장소에서 온 필터 정리 (순수): 문자열·숫자만, 연산자는 목록 안, 빌더 트리는 깊이 16·항목 500 까지 */
export function sanitizeFilters(f) {
    if (!f || typeof f !== 'object')
        return undefined;
    const out = {};
    if (Array.isArray(f.row))
        out.row = f.row.filter((x) => Array.isArray(x) && typeof x[0] === 'string' && typeof x[1] === 'string' && x[1].length <= 2000).slice(0, 500).map((x) => [x[0], x[1]]);
    if (f.menu && typeof f.menu === 'object' && !Array.isArray(f.menu)) {
        const m = {};
        for (const [k, v] of Object.entries(f.menu).slice(0, 500)) {
            if (!v || typeof v !== 'object')
                continue;
            const cf = {};
            if (Array.isArray(v.values))
                cf.values = v.values.filter((x) => typeof x === 'string').slice(0, 100000);
            const c = v.cond;
            if (c && typeof c === 'object' && FILTER_OPS.includes(c.op) && (c.value === undefined || primOrList(c.value)) && (c.value2 === undefined || prim(c.value2))) {
                cf.cond = { op: c.op, ...(c.value !== undefined ? { value: c.value } : {}), ...(c.value2 !== undefined ? { value2: c.value2 } : {}), ...(typeof c.preset === 'string' && DATE_PRESET_KEYS.includes(c.preset) ? { preset: c.preset } : {}) };
            }
            if (cf.values || cf.cond)
                m[k] = cf;
        }
        out.menu = m;
    }
    let budget = 500;
    const node = (n, d) => {
        if (!n || typeof n !== 'object' || d > 16 || --budget < 0)
            return null;
        if (n.kind === 'expr')
            return typeof n.expr === 'string' && n.expr.length <= 4000 ? { kind: 'expr', expr: n.expr } : null;
        if (n.kind === 'cond')
            return typeof n.col === 'string' && FILTER_OPS.includes(n.op) && (n.value === undefined || primOrList(n.value)) && (n.value2 === undefined || prim(n.value2)) ? { kind: 'cond', col: n.col, op: n.op, ...(n.value !== undefined ? { value: n.value } : {}), ...(n.value2 !== undefined ? { value2: n.value2 } : {}), ...(n.not === true ? { not: true } : {}) } : null;
        if (n.kind === 'group' && Array.isArray(n.items))
            return { kind: 'group', logic: n.logic === 'OR' ? 'OR' : 'AND', ...(n.not === true ? { not: true } : {}), items: n.items.map((x) => node(x, d + 1)).filter((x) => !!x) };
        return null;
    };
    if ('adv' in f)
        out.adv = f.adv == null ? null : node(f.adv, 0);
    if (typeof f.enabled === 'boolean')
        out.enabled = f.enabled;
    return out;
}
/** 행 상태 레이아웃(키) → 물리 행 (순수). findRow 가 -1 이면 그 키는 missing 에 */
export function resolveRowState(rs, findRow) {
    const missing = [];
    const row = (k) => { const r = findRow(k); if (r < 0)
        missing.push(k); return r; };
    const rows = (a) => (a ?? []).map(row).filter(r => r >= 0);
    const heights = new Map(), locks = new Map();
    for (const [k, h] of rs.heights ?? []) {
        const r = row(k);
        if (r >= 0)
            heights.set(r, Math.max(16, Math.min(400, Math.round(h))));
    }
    const hidden = rows(rs.hidden), pinTop = rows(rs.pinTop), pinBottom = rows(rs.pinBottom);
    for (const [a, v] of [[rs.locked, true], [rs.unlocked, false]])
        for (const [k, c] of a ?? []) {
            const r = row(k);
            if (r >= 0)
                locks.set(r + ':' + c, v);
        }
    return { heights, hidden, pinTop, pinBottom, locks, protect: rs.protect, missing };
}
/** 보기 순서에서 rows 를 target 앞(before)·뒤(after)로 옮긴 새 순서 (순수). target 이 없으면 끝에 */
export function reorderRows(order, rows, target, pos) {
    const mv = new Set(rows), v = Array.from(order).filter(r => !mv.has(r));
    let at = v.indexOf(target);
    at = at < 0 ? v.length : at + (pos === 'after' ? 1 : 0);
    v.splice(at, 0, ...rows);
    return v;
}
/** 저장해 둔 순서(order)를 지금 보기(current)에 입힘 (순수): current 에 있는 행만 order 순으로, order 에 없는 행은 원래 순서대로 뒤에 */
export function mergeViewOrder(order, current) {
    const cur = new Set(Array.from(current)), seen = new Set(), out = [];
    for (const r of Array.from(order))
        if (cur.has(r) && !seen.has(r)) {
            out.push(r);
            seen.add(r);
        }
    for (const r of Array.from(current))
        if (!seen.has(r)) {
            out.push(r);
            seen.add(r);
        }
    return out;
}
export const LAYOUT_COLUMN_KEYS = ['id', 'header', 'width', 'hidden', 'pinned', 'align', 'format', 'decimals', 'dateFormat', 'editor', 'comboShow', 'required', 'wrap', 'sortable', 'filterable', 'summary', 'summaries', 'summaryExpr', 'suppress', 'merge', 'groupInterval', 'maxLength', 'upper', 'expr', 'privacy'];
export const LAYOUT_OPTION_KEYS = ['rowHeight', 'headerHeight', 'editable', 'showRowNumber', 'showRowState', 'showCheckbox', 'showFilterRow', 'showFooter', 'footerLabel', 'enterKey', 'appendRowOnTab', 'columnFilterMenu', 'showFilterPanel', 'showGroupPanel', 'hideGroupedColumns', 'findPanel', 'incrementalSearch', 'rowDrag', 'emptyText', 'contextMenu', 'compact', 'striped', 'pageSize', 'autoRowHeight'];
export const MAX_SCROLL_PX = 8000000;
export const CHOSUNG = 'ㄱㄲㄴㄷㄸㄹㅁㅂㅃㅅㅆㅇㅈㅉㅊㅋㅌㅍㅎ';
export function chosung(s) {
    let o = '';
    for (const ch of s) {
        const c = ch.charCodeAt(0) - 0xac00;
        o += c >= 0 && c < 11172 ? CHOSUNG[Math.floor(c / 588)] : ch;
    }
    return o;
}
export function esc(s) { return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
export function download(data, filename, mime) {
    const blob = new Blob([data], { type: mime });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
}
/** 2단 헤더 그룹 구간: 같은 패인에서 이웃한 같은 그룹 컬럼끼리 묶음 */
/** 누적합 증분 갱신 (순수): vi 행 높이가 d 만큼 바뀌면 offs[vi+1..] 에 더함. 여러 건은 한 번에 */
export function applyRowDeltas(offs, changes) {
    if (!changes.length)
        return;
    const ch = [...changes].sort((a, b) => a.vi - b.vi), n = offs.length - 1;
    let acc = 0, j = 0;
    for (let k = ch[0].vi; k < n; k++) {
        while (j < ch.length && ch[j].vi === k)
            acc += ch[j++].d;
        offs[k + 1] += acc;
    }
}
/** 멀티로우 그룹 머리글: 그룹·패인마다 소속 셀들의 가로 범위를 합친 하나 (레이아웃 셀만) */
export function mlGroupSegments(cols, groupOf) {
    const out = [];
    for (const c of cols) {
        const g = groupOf.get(c.id);
        if (!g || c.lc == null)
            continue;
        const cur = out.find(x => x.group === g && x.pane === c.pane);
        if (!cur) {
            out.push({ group: g, pane: c.pane, left: c.left, width: c.width, ids: [c.id] });
            continue;
        }
        const r = Math.max(cur.left + cur.width, c.left + c.width);
        cur.left = Math.min(cur.left, c.left);
        cur.width = r - cur.left;
        cur.ids.push(c.id);
    }
    return out;
}
export function headerGroupSegments(cols, groupOf) {
    const out = [];
    let cur = null;
    for (const c of cols) {
        const g = groupOf.get(c.id);
        if (g && cur && cur.group === g && cur.pane === c.pane && Math.abs(cur.left + cur.width - c.left) < 1) {
            cur.width += c.width;
            cur.ids.push(c.id);
            continue;
        }
        cur = g ? { group: g, pane: c.pane, left: c.left, width: c.width, ids: [c.id] } : null;
        if (cur)
            out.push(cur);
    }
    return out;
}
export const KEY_ACTIONS = ['nextCell', 'prevCell', 'nextRow', 'prevRow', 'firstCell', 'lastCell', 'beginEdit', 'cancelEdit', 'commitAndDown', 'commitAndRight', 'addRow', 'deleteRow', 'undo', 'redo', 'save', 'find', 'replace', 'copy', 'sendRows', 'fillDown', 'fillRight', 'restoreRow', 'saveRow', 'cancelRow', 'none'];
const KEY_NAMES = ['Enter', 'Tab', 'Escape', 'Delete', 'Insert', 'Backspace', 'Home', 'End', 'PageUp', 'PageDown', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Space', ...Array.from({ length: 12 }, (_, i) => 'F' + (i + 1))];
const KEY_ALIAS = { esc: 'Escape', del: 'Delete', ins: 'Insert', up: 'ArrowUp', down: 'ArrowDown', left: 'ArrowLeft', right: 'ArrowRight', pgup: 'PageUp', pgdn: 'PageDown', return: 'Enter', ' ': 'Space', spacebar: 'Space' };
const comboStr = (ctrl, meta, alt, shift, key) => [ctrl && 'Ctrl', meta && 'Meta', alt && 'Alt', shift && 'Shift', key].filter(Boolean).join('+');
/** 'ctrl+shift+s' → 'Ctrl+Shift+S' (순수, 수식키 순서 고정) */
export function normalizeKeyCombo(s) {
    let key = '';
    if (s === '+' || s.endsWith('++')) {
        key = '+';
        s = s.slice(0, -1);
    }
    const parts = s.split('+').map(x => x.trim()).filter(Boolean);
    let ctrl = false, meta = false, alt = false, shift = false;
    for (const p0 of parts) {
        const p = p0.toLowerCase();
        if (p === 'ctrl' || p === 'control')
            ctrl = true;
        else if (p === 'meta' || p === 'cmd' || p === 'command')
            meta = true;
        else if (p === 'alt' || p === 'option')
            alt = true;
        else if (p === 'shift')
            shift = true;
        else
            key = KEY_ALIAS[p] ?? KEY_NAMES.find(n => n.toLowerCase() === p) ?? (p0.length === 1 ? p0.toUpperCase() : p0);
    }
    return comboStr(ctrl, meta, alt, shift, key);
}
/** 키 이벤트 → 'Ctrl+Shift+S' (글자·숫자는 e.code 기준 — 한글 자판에서도 Ctrl+S) */
export function keyComboOf(e) {
    const key = /^Key[A-Z]$/.test(e.code ?? '') ? e.code.slice(3) : /^Digit\d$/.test(e.code ?? '') ? e.code.slice(5) : e.key === ' ' ? 'Space' : e.key.length === 1 ? e.key.toUpperCase() : e.key;
    return comboStr(e.ctrlKey, e.metaKey, e.altKey, e.shiftKey, key);
}
export const COL_TYPES = new Set(['string', 'number', 'date', 'boolean']);
/** Dataset → 컬럼 정의 자동 생성 (순수). 숫자: 오른쪽·천 단위(소수 자리는 앞 500행에서 최대 2), 날짜: 날짜 서식, 참/거짓: 가운데(체크 편집기), 너비: 머리글·값 길이 */
export function autoColumns(ds, labels) {
    const n = Math.min(ds.length, 500);
    const wOf = (s) => { let w = 0; for (const ch of s)
        w += ch.charCodeAt(0) > 0x2e80 ? 13 : 7.5; return w; };
    return ds.columns.map(dc => {
        const header = labels?.[dc.id] ?? dc.id;
        const c = { id: dc.id, header };
        let w = wOf(header) + 24;
        if (dc.type === 'number') {
            let dec = 0;
            for (let r = 0; r < n; r++) {
                const v = ds.get(r, dc.id);
                if (typeof v === 'number' && !Number.isInteger(v))
                    dec = Math.max(dec, Math.min(2, (String(v).split('.')[1] ?? '').length));
            }
            c.format = 'number';
            if (dec)
                c.decimals = dec;
            c.align = 'right';
        }
        else if (dc.type === 'date')
            c.format = 'date';
        else if (dc.type === 'boolean')
            c.align = 'center';
        for (let r = 0; r < n; r++) {
            const v = ds.get(r, dc.id);
            if (v != null)
                w = Math.max(w, wOf(String(v)) + 16);
        }
        c.width = Math.round(Math.max(60, Math.min(300, dc.type === 'date' ? Math.max(w, 96) : w)));
        return c;
    });
}
/** columnTypes 해석 (순수): type 이 columnTypes 이름(들)이면 그 정의를 차례로 깔고 컬럼 속성으로 덮음. valueGetter → value, valueFormatter → format */
export function resolveColumnTypes(cols, types) {
    return cols.map(c0 => {
        if (c0.__resolved)
            return c0;
        let c = c0;
        const names = Array.isArray(c.type) ? c.type : typeof c.type === 'string' && types && types[c.type] && !COL_TYPES.has(c.type) ? [c.type] : typeof c.type === 'string' && types?.[c.type] ? [c.type] : [];
        if (names.length) {
            const base = {};
            for (const n of names) {
                const t = types?.[n];
                if (t)
                    Object.assign(base, t);
            }
            const own = { ...c };
            delete own.type;
            c = { ...base, ...own };
            const dt = base.type;
            if (typeof dt === 'string' && COL_TYPES.has(dt))
                c.type = dt;
            else {
                const last = names.find(n => COL_TYPES.has(n));
                if (last)
                    c.type = last;
                else
                    delete c.type;
            }
        }
        if (c.valueGetter && !c.value) {
            const g = c.valueGetter, id = c.id;
            c = { ...c, value: (row, ds) => g({ row, ds, col: id }) };
        }
        if (c.valueFormatter && typeof c.format !== 'function') {
            const f = c.valueFormatter, id = c.id;
            c = { ...c, format: (v, row, ds) => f({ value: v, row, ds, col: id }) };
        }
        if (c !== c0)
            Object.defineProperty(c, '__resolved', { value: true, enumerable: false });
        return c;
    });
}
/** 컬럼 summary 가 사용자 정의(함수·가중 평균·{fn}) 인가 — 집계 이름 문자열이 아님 */
export function isCustomSummary(s) { return typeof s === 'function' || (!!s && typeof s === 'object'); }
export const AGG_LABEL = { sum: '합계', avg: '평균', count: '건수', min: '최소', max: '최대' };
/** 컬럼의 집계 종류 목록 (summaries 우선, 문자열 summary 는 한 개) */
export function colAggs(d) { return d.summaries?.length ? d.summaries : typeof d.summary === 'string' ? [d.summary] : []; }
/** 다중 합계 푸터 줄: summaries 를 쓰는 컬럼이 있으면 등장 순서대로 집계 종류 합집합, 없으면 null (한 줄) */
export function footerLines(defs) {
    if (!defs.some(d => d.summaries?.length))
        return null;
    const out = [];
    for (const d of defs)
        for (const k of colAggs(d))
            if (!out.includes(k))
                out.push(k);
    return out;
}
/**
 * 바깥을 누르면 닫기: 다음 틱에 document mousedown(캡처)을 등록 (여는 클릭이 바로 닫지 않게). 돌려준 함수로 해제.
 * 등록 전에 해제해도(열자마자 닫기·destroy) 나중에 등록되지 않음 — 14차 수정 (예전에는 리스너가 남아 그리드 전체가 GC 안 됨)
 */
export function onOutsideMouseDown(fn) {
    let off = false;
    const t = setTimeout(() => { if (!off)
        document.addEventListener('mousedown', fn, true); });
    return () => { off = true; clearTimeout(t); document.removeEventListener('mousedown', fn, true); };
}
/**
 * 그리드 밖 팝업 붙이기 (1.2.0): 붙일 곳(popupContainer, 기본 body) · 그리드의 --og-* 값 복사(조상에서 준 앱 변수·테마가 body 팝업에도) ·
 * data-og-theme · z-index 기준(--og-z = zIndexBase, 기본 1000)
 */
export function mountPopup(grid, el, container) {
    const pc = grid.opts.popupContainer;
    const host = container ?? (typeof pc === 'function' ? pc(grid) : pc) ?? document.body;
    if (grid.root.isConnected) {
        const cs = getComputedStyle(grid.root);
        for (const k of ogVarNames()) {
            const v = cs.getPropertyValue(k);
            if (v)
                el.style.setProperty(k, v.trim());
        }
        const th = grid.root.closest('[data-og-theme]')?.getAttribute('data-og-theme');
        if (th)
            el.setAttribute('data-og-theme', th);
    }
    el.style.setProperty('--og-z', String(Math.round(grid.opts.zIndexBase ?? 1000)));
    host.appendChild(el);
    return el;
}
/** position:fixed 팝업을 화면 좌표에 맞춤 — 붙인 곳의 조상에 transform 이 있으면(모달 가운데 정렬 등) 그만큼 되돌림 */
export function fixFixedPos(el) {
    const l = parseFloat(el.style.left), t = parseFloat(el.style.top);
    if (isNaN(l) || isNaN(t))
        return;
    const r = el.getBoundingClientRect();
    if (Math.abs(r.left - l) > 0.5)
        el.style.left = l + (l - r.left) + 'px';
    if (Math.abs(r.top - t) > 0.5)
        el.style.top = t + (t - r.top) + 'px';
}
/** 대화상자 id 번호 (모든 그리드 공용 — aria-labelledby 등이 겹치지 않게) */
let dlgSeq = 0;
export function nextDlgSeq() { return ++dlgSeq; }
/**
 * 믹스인 연결: 묶음 클래스(grid-*.ts)의 메서드·접근자를 대상 prototype 에 같은 속성 설명자(열거 안 됨 — class 메서드와 같음)로 붙인다.
 * 이름이 겹치면(같은 메서드를 두 곳에 둠) 모듈을 읽을 때 바로 오류
 */
export function applyMixins(target, sources) {
    for (const s of sources)
        for (const k of Object.getOwnPropertyNames(s.prototype)) {
            if (k === 'constructor')
                continue;
            if (Object.prototype.hasOwnProperty.call(target.prototype, k))
                throw new Error('OneGrid 믹스인 이름 겹침: ' + k);
            Object.defineProperty(target.prototype, k, Object.getOwnPropertyDescriptor(s.prototype, k));
        }
}
